import { Datum, Serie } from "@nivo/line";
import { BarDatum } from "@nivo/bar";

import { DEFAULT_CURRENCY_SYMBOL } from "@zenith/data/constants";
import {
  SalesOverTimeMonthDTO,
  SalesOverTimeWeekDTO,
} from "@zenith/services/transactions";
import {
  BarChartComponent,
  LineChartComponent,
} from "@zenith/features/Analytics";
import { memo } from "react";

export interface SalesOverTimeComponentProps {
  graphData: SalesOverTime[] | undefined;
}

interface SalesOverTime extends SalesOverTimeMonthDTO, SalesOverTimeWeekDTO {}

const SalesOverTimeComponent = memo(function SalesOverTimeComponent(
  props: SalesOverTimeComponentProps
) {
  const { graphData } = props;

  const lineChartDataArray: Datum[] = [];
  const barChartData: BarDatum[] = [];

  graphData?.forEach((entry: SalesOverTime) => {
    lineChartDataArray.push({
      x: (entry.numberOfDay as number) || (entry.weekDay as string),
      y: entry.quantity as number,
    });
    barChartData.push({
      days: (entry.weekDay as string) || (entry.numberOfDay as number),
      amount: entry.amount as number,
    });
  });

  const lineChartData: Serie[] = [
    {
      id: "sales-value-over-time-line-chart",
      data: lineChartDataArray,
    },
  ];

  return (
    <div className="grid w-full grid-cols-1 gap-3 lg:grid-cols-2">
      <div className="">
        <div className="mb-4 h-7 items-center justify-start pl-4 pr-2 text-xl font-medium leading-7 text-zinc-900">
          Sales Value Over Time ({DEFAULT_CURRENCY_SYMBOL})
        </div>
        <BarChartComponent
          data={barChartData}
          margin={{ top: 50, right: 10, bottom: 50, left: 65 }}
          indexBy={"days"}
          keys={["amount"]}
          layout="vertical"
          legend="Days"
          height={385}
        />
      </div>

      <div className="">
        <div className="mb-4 h-7 items-center justify-start pl-4 pr-2 text-xl font-medium leading-7 text-zinc-900">
          Number of Sales Over Time
        </div>
        <LineChartComponent data={lineChartData} />
      </div>
    </div>
  );
});

export default SalesOverTimeComponent;
